<ui-modal [header]="false" [footer]="false" size="md">

	<h3 class="mb-2">{{outstanding ? 'Have you completed these?' : 'All done'}}</h3>
	<p *ngIf="outstanding" class="text-secondary mb-3">
		This deal was asked to finish
		<ng-container *ngIf="outstanding === 1">one thing</ng-container>
		<ng-container *ngIf="outstanding > 1">{{outstanding}} things</ng-container>
		before {{stepName}}.
	</p>

	<!-- Every outstanding item, and where it came from. The stage matters: work asked for in an
	     earlier lane of the same segment still counts, and somebody looking at this needs to know
	     why they are being asked about a stage the deal has already left.

	     Both kinds are here — work an automation asked for, and follow-ups somebody set — because
	     both hold the deal and being refused by something the dialog did not list is being told
	     no twice. -->
	<div *ngFor="let item of items" class="d-flex align-items-start border rounded p-3 mb-2">
		<i class="wq text-secondary mr-3 mt-1" [ngClass]="isQuestion(item) ? 'wq-help'
			: (item.resolve_mode === 'event' ? 'wq-schedule' : 'wq-checkbox-unchecked')"></i>
		<div class="flex-weight-1 min-width-0">
			<div class="text-bold">
				{{item.description}}
				<span *ngIf="item.resolve_mode === 'file'" class="badge badge-light border ml-2">File</span>
				<!-- Said, because the two are cleared differently and one of them is somebody's
				     own reminder rather than a check the pipeline asked for. -->
				<span *ngIf="item.kind === 'follow_up'" class="badge badge-light border ml-2">Follow-up</span>
			</div>

			<!-- What the check actually asks for. An automation that did not name its check gets
			     the generic description, so without this two of them read as the same row twice —
			     and the note the action wrote is where the instruction lives. -->
			<div *ngIf="item.note_summary" class="text-small mt-1">{{item.note_summary}}</div>

			<div class="text-secondary text-tiny mt-1">
				<span *ngIf="item.stage_name">{{item.stage_name}}</span>
				<span *ngIf="item.stage_name && item.automation_name"> &middot; </span>
				<span *ngIf="item.automation_name">Asked by {{item.automation_name}}</span>
				<span *ngIf="item.kind === 'follow_up'">Set on this deal</span>
				<ng-container *ngIf="item.created_datetime">
					&middot; raised {{item.created_datetime | mySQLDateToISO | localizedDate:'short'}}
				</ng-container>
				<ng-container *ngIf="item.due">
					&middot; follow-up {{item.due | mySQLDateToISO | localizedDate:'short'}}
				</ng-container>
				<ng-container *ngIf="item.assignee_name">
					&middot; {{item.assignee_name}}
				</ng-container>
			</div>

			<!-- Said before the press, not after it: the server refuses a file request until the
			     file is on the deal, and finding that out by being refused is this dialog wasting
			     somebody's time. -->
			<div *ngIf="item.resolve_mode === 'file'" class="text-secondary text-tiny mt-1">
				<i class="wq wq-upload mr-1"></i>Attach the file to the deal first, then mark this done.
			</div>
			<div *ngIf="isQuestion(item)" class="text-secondary text-tiny mt-1">
				The automation waits for the answer, then carries on down the branch it picks.
			</div>
			<div *ngIf="item.resolve_mode === 'event'" class="text-secondary text-tiny mt-1">
				The deal needs a site visit. Book it, and the automation carries on once it has happened.
			</div>
		</div>
		<!-- The server refuses to tick the question or the booking, so each gets the control the
		     deal's own card has. File requests still resolve by marking done (CRM-155). -->
		<ng-container [ngSwitch]="isQuestion(item) ? 'answer' : item.resolve_mode">
			<div *ngSwitchCase="'answer'" class="d-flex align-items-center nowrap ml-3">
				<ng-container *ngIf="answeringId !== item.id">
					<button type="button" class="btn btn-outline-secondary btn-sm mr-1" [disabled]="disabled" (click)="answer(item, true)">Yes</button>
					<button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="disabled" (click)="answer(item, false)">No</button>
				</ng-container>
				<span *ngIf="answeringId === item.id" class="text-secondary text-small">
					<span class="spinner-border spinner-border-sm mr-2"></span>Saving answer&hellip;
				</span>
			</div>
			<button *ngSwitchCase="'event'" type="button" class="btn btn-primary btn-sm nowrap ml-3"
					[disabled]="disabled" (click)="bookSiteVisit()">
				<i class="wq wq-schedule mr-2"></i>Book site visit
			</button>
			<button *ngSwitchDefault type="button" class="btn btn-outline-secondary btn-sm nowrap ml-3"
					[disabled]="disabled" (click)="markComplete(item)">
				<i class="wq wq-check mr-2"></i>Mark complete
			</button>
		</ng-container>
	</div>

	<div *ngIf="!outstanding" class="alert alert-success mb-2">
		<i class="wq wq-check mr-2"></i>Nothing left outstanding. Carry on.
	</div>

	<!-- Said plainly, because it is true and hiding it would make this read as a wall it is not:
	     the quote's own status is still the authority, and taking that route is recorded. -->
	<p *ngIf="hasEscapeHatch" class="text-secondary text-tiny mt-3 mb-0">
		These are checks your pipeline asked for, not a lock. If one no longer applies you can set
		the quote's status directly — the deal records that it moved on with the item outstanding.
	</p>
	<p *ngIf="!hasEscapeHatch" class="text-secondary text-tiny mt-3 mb-0">
		These are checks your pipeline asked for. The deal stays where it is until they are done —
		a quote reaching its next status still moves it, whatever is outstanding here.
	</p>

	<hr>

	<div class="d-flex align-items-center">
		<button type="button" class="btn btn-outline-secondary btn-sm" (click)="openDeal()">
			<i class="wq wq-chart mr-2"></i>Review in deal
		</button>
		<div class="flex-weight-1"></div>
		<button type="button" class="btn btn-medium mr-2" (click)="cancelButton()">Cancel</button>
		<button type="button" class="btn btn-primary" [disabled]="outstanding || disabled" (click)="continueButton()">
			Continue
		</button>
	</div>

</ui-modal>
